module.exports = __webpack_public_path__ + "static/img/mode2.0d78993.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/mode2.png
// module id = kVWP
// module chunks = 1